import React, { useState } from "react";
import { Button, Menu, IconButton } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SaveIcon from "@mui/icons-material/Save";
import BaseHeader from "../Common/BaseHeader";

const Header = ({
  canEdit = true,
  company,
  handleSave,
  onExcelUpload,
  currency,
  crossYAApportionmentContext,
  children,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const actions = (
    <>
      {canEdit && onExcelUpload && (
          <Button
            variant='outlined'
            startIcon={<UploadFileIcon />}
            onClick={onExcelUpload}
            sx={{ textTransform: "none" }}
          >
            Upload Excel
          </Button>
      )}
      {canEdit && (
        <Button
          variant='contained'
          color='success'
          onClick={handleSave}
          startIcon={<SaveIcon />}
          sx={{
            textTransform: "none",
          }}
        >
          Save
        </Button>
      )}

      <IconButton
        onClick={handleMenuOpen}
        sx={{
          backgroundColor: "#F5F5F5",
          borderRadius: "8px",
          transition: "all 0.2s ease-in-out",
          "&:hover": { backgroundColor: "#E0E0E0" },
        }}
      >
        <MoreVertIcon sx={{ color: "#424242" }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        sx={{
          mt: 1,
          "& .MuiPaper-root": {
            borderRadius: "12px",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.1)",
            minWidth: 200,
          },
        }}
      >
        {children}
      </Menu>
    </>
  );

  return (
    <BaseHeader
      title='Main Tax Computation'
      companyName={company.name}
      uen={company.uen}
      yearOfAssessment={company.yearOfAssessment}
      financialYearStart={company.financialYearStart}
      financialYearEnd={company.financialYearEnd}
      currency={currency}
      actions={actions}
      companyType={company.companyType || "common"}
      showPrecedingDays={company.taxPeriodType === "cross_ya"}
      crossYAApportionmentContext={crossYAApportionmentContext}
    />
  );
};

export default Header;
